import { Component, ViewChild, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/services/error-handler.service'
import { HttpService } from '../../shared/services/http.service'
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { MdAutocompleteTrigger, MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../../dialog/dialog.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';

@Component({
    selector: 'request-add',
    template: require('./create.component.html'),
    styles: [require('./create.component.scss')],
    providers: [HttpService, ErrorHandler,SessionHandler]
})

export class viewRequestAddComponent {

    dialogRef;
    requestOrder:any;
	id:any;	
    userData:any;
    tradeData:any = {};
    formData:any;
    uploadedDocList:any=[];
    contactList: any;
    isAnyChanged:boolean=false;
    showingMediaErrorMsg:any;
    showingmediaError:any;
    returnOrderId:any;
    data: any;
    hideUpdateButton: any;
    isD2cUser=false;


contactNameCtrl = new FormControl('', Validators.required);

contactEmailCtrl = new FormControl('', [
  Validators.required,
  Validators.email
]);

contactPhoneCtrl = new FormControl('', Validators.required);
private isInitialisingContact = false;

 isTempContact:boolean = false;
    isExistingContactSelected:boolean = false;
    isContactModified: boolean = false;
    private _originalContact: any = null;

filteredEmails: Observable<any[]>;
filteredPhones: Observable<any[]>;
filteredContacts: Observable<any[]>;
@ViewChildren(MdAutocompleteTrigger) private _triggers: QueryList<MdAutocompleteTrigger>;

	constructor(private router: Router,private route: ActivatedRoute,private http:HttpService,private commonService : CommonService,
    private sessionHandler:SessionHandler,public dialog: MdDialog) {
        console.log("####")

        this.requestOrder = {};
        this.userData = {};
        if(this.http.checkSession()){
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.route.params.subscribe(params => {
                console.log('Route Param ID = ', params['id']);
                this.id = +params['id'];
                console.log('Parsed ID = ', this.id);
            });
            let data = this.commonService.getData();
            if(this.userData){
                if(!isNaN(this.id)){
                    console.log("####")
                    this.getRequestDataWithId();
                    // if(data && data['requestOrder']) {
                    //     this.formData = data;
                    //     this.commonService.changeViewData(this.formData);
                    //     this.requestOrder = data['requestOrder'];
                    // } else {
                    //     this.getRequestDataWithId();
                    // }
                }
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() {

        console.log("####")

    }

    public getTradeData(id){
        this.http.getRequest('tradePartnerDetails/v1/get?tradePartnerId='+ id)
        .subscribe(
            res => {
                this.saveTradeData(res)
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
        });
    }
    
    public saveTradeData(res) {
        if(res.status == "Success") {
            this.tradeData = res.tradePartner;
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to fetch trade data.';
        }
        this.http.onEnd();
    }

    public getRequestDataWithId() {
        console.log("####")
        this.http.getRequest('returnOrder/v1/getReturnOrder?orderId='+ this.id)
        .subscribe(
            res => {this.saveRequestData(res)
                console.log("####")
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = err;

                }
                this.http.onEnd();
        });        
    }

    public saveRequestData(res){
        console.log("inside saveRequestData",res,res.returnReqDto['status']);
        this.isD2cUser=false;/**check for d2c user */
        if(res.responseStatus == 'Success'){
            this.isD2cUser=res.returnReqDto.d2C;/**check for d2c user */
            this.requestOrder = res.returnReqDto.requestOrder;  
            if(this.isD2cUser){/**for d2c user one time address set*/
                this.setd2cUserAddress(res.returnReqDto.requestOrder);          
            }
            this.formData = res.returnReqDto;
            this.getTradeData(this.formData.tradePartnerId);
            this.commonService.changeViewData(this.formData);
            res.returnReqDto['status']=="REJECTED_FOR_INCOMPLETENESS"?this.hideUpdateButton=true:this.hideUpdateButton=false;
            console.log(this.hideUpdateButton);
            //this.uploadedDocList = res.returnReqDto.uploadedDocList;
            this.returnOrderId=
            {
                transactionId:res.returnReqDto.sapReturnOrderId
            }
            this.imageShow(this.returnOrderId);     //Call ServiceDoc Api
          
            this.getContactList('new');
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Could not load data for this request.';
            this.http.onEnd();
        }
        // this.http.onEnd();
    }

    imageShow(data){
        this.http.showLoader();
        this.http.downloadPostRequest('document/downloadDocument',data).subscribe(
          res => {
            this.sanitizeUrl(res['data'])
            this.http.onEnd();
        },
         err => {
            this.http.onEnd();
           this.showingMediaErrorMsg ="error in fetch image data";
           this.showingmediaError =true;
         }
        );   
    }
    sanitizeUrl(data){

        this.uploadedDocList =data;
        console.log(this.uploadedDocList);
    }
    


    public goToNextPage() {
       this.commonService.setData(this.formData);
       this.router.navigateByUrl('/app/view/return/'+this.id);
       
    }

    public navigateDocLink(docUrl){    
        this.dialogRef = this.dialog.open(viewDialog);
        this.dialogRef.componentInstance.urlList = docUrl;
        this.http.onEnd();
    }

        public getContactList(action = null) {
        let tradeId;
        tradeId=this.formData.tradePartnerId;
        this.http.getRequest('userOperationsApi/v1/getContacts?tradePartnerId=' + tradeId)
            .subscribe(
                res => { this.saveContactList(res, action) },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
    }
    public saveContactList(res, action) {
    this.contactList = res.items || [];

    this.setupContactFilters();

    if (this.requestOrder) {
        this.isInitialisingContact = true;
        this.contactNameCtrl.setValue(
            this.requestOrder.contactName || '',
            { emitEvent: false }
        );

        this.contactEmailCtrl.setValue(
            this.requestOrder.contactEmail || '',
            { emitEvent: false }
        );

        this.contactPhoneCtrl.setValue(
            this.requestOrder.contactPhone || '',
            { emitEvent: false }
        );
        this.isInitialisingContact = false;
    }

    this.http.onEnd();
}

private setupContactFilters() {

    this.filteredContacts = this.contactNameCtrl.valueChanges.pipe(
        startWith(''),
        debounceTime(150),
        map(value => this.filterContacts(value, 'name'))
    );

    this.filteredEmails = this.contactEmailCtrl.valueChanges.pipe(
        startWith(''),
        debounceTime(150),
        map(value => this.filterContacts(value, 'email'))
    );

    this.filteredPhones = this.contactPhoneCtrl.valueChanges.pipe(
        startWith(''),
        debounceTime(150),
        map(value => this.filterContacts(value, 'phone'))
    );
    this.contactNameCtrl.valueChanges.subscribe(value => {
    if (this.isInitialisingContact) return;

    if (typeof value === 'string') {
        this.requestOrder.contactName = value;
        this.selectChanged();
    }
});

this.contactEmailCtrl.valueChanges.subscribe(value => {
    if (this.isInitialisingContact) return;

    if (typeof value === 'string') {
        this.requestOrder.contactEmail = value;
        this.selectChanged();
    }
});

this.contactPhoneCtrl.valueChanges.subscribe(value => {
    if (this.isInitialisingContact) return;

    if (typeof value === 'string') {
        this.requestOrder.contactPhone = value;
        this.selectChanged();
    }
});
}

private filterContacts(value: any, type: string): any[] {

    if (!this.contactList) {
        return [];
    }

    const search = typeof value === 'string'
        ? value.toLowerCase()
        : '';

    return this.contactList.filter(contact => {

        if (type === 'name') {
            return (contact.contactName || '')
                .toLowerCase()
                .includes(search);
        }

        if (type === 'email') {
            return (contact.contactEmail || '')
                .toLowerCase()
                .includes(search);
        }

        if (type === 'phone') {
            return String(contact.contactPhone || '')
                .toLowerCase()
                .includes(search);
        }

        return false;
    });
}


    displayContact = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactName ? value.contactName : '');

displayEmail = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactEmail ? value.contactEmail : '');

displayPhone = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactPhone ? value.contactPhone : '');


onContactSelected(event: any, contact: any) {

    if (!event.isUserInput) {
        return;
    }

    this.populateContact(contact);
}

emailSelected(event: any, contact: any) {

    if (!event.isUserInput) {
        return;
    }

console.log(
  'email value',
  this.contactEmailCtrl.value,
  'errors',
  this.contactEmailCtrl.errors
);

    
this.contactEmailCtrl.setValue(contact.contactEmail || '', { emitEvent: false });

  this.requestOrder.contactEmail = contact.contactEmail || '';

   this.selectChanged();

   
console.log(
  'email value',
  this.contactEmailCtrl.value,
  'errors',
  this.contactEmailCtrl.errors
);

}

phoneSelected(event: any, contact: any) {

    if (!event.isUserInput) {
        return;
    }

    this.contactPhoneCtrl.setValue(contact.contactPhone || '', { emitEvent: false });

  this.requestOrder.contactPhone = contact.contactPhone || '';

  this.selectChanged();

}
private populateContact(contact: any) {

    this.contactNameCtrl.setValue(contact.contactName || '', { emitEvent: false });
    this.contactEmailCtrl.setValue(contact.contactEmail || '', { emitEvent: false });
    this.contactPhoneCtrl.setValue(contact.contactPhone || '', { emitEvent: false });

    this.requestOrder.contactName = contact.contactName || '';
    this.requestOrder.contactEmail = contact.contactEmail || '';
    this.requestOrder.contactPhone = contact.contactPhone || '';

    this.selectChanged();
}


openPanelFor(auto: any, list: any[]) {

    if (!list || !list.length) {
        return;
    }

    setTimeout(() => {
        this._triggers.forEach(trigger => {
            if (trigger && !trigger.panelOpen) {
                trigger.openPanel();
            }
        });
    });
}
 private _asText(
  val: any,
  kind: 'name' | 'email' | 'phone' | 'address' | 'soldTo'
): string {
  if (val == null) return '';

  if (typeof val === 'string') return val.trim();

  if (typeof val === 'object') {
    if (kind === 'name')    return (val.contactName || '').trim();
    if (kind === 'email')   return (val.contactEmail || '').trim();
    if (kind === 'phone')   return (val.contactPhone || '').trim();
    if (kind === 'address') return (val.address || '').trim();

    // ✅ sold-to / trade partner
    if (kind === 'soldTo') {
      return (
        val.soldTo ||
        val.tradePartnerId ||
        val.id ||
        ''
      ).toString().trim();
    }
  }

  return String(val || '').trim();
}
 getHighlightedParts(
  text: string,
  search: any,
  kind: 'name' | 'email' | 'phone' | 'address' | 'soldTo'
): { value: string; match: boolean }[] {

  if (!text) {
    return [{ value: '', match: false }];
  }

  const term = this._asText(search, kind);


  if (!term) {
    return [{ value: text, match: false }];
  }

  const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(escaped, 'ig');

  const parts: { value: string; match: boolean }[] = [];
  let lastIndex = 0;
  let m: RegExpExecArray | null;

  while ((m = regex.exec(text)) !== null) {
    const start = m.index;
    const end = start + m[0].length;

    if (start > lastIndex) {
      parts.push({
        value: text.substring(lastIndex, start),
        match: false
      });
    }

    parts.push({
      value: m[0],
      match: true
    });

    lastIndex = end;
  }

  if (lastIndex < text.length) {
    parts.push({
      value: text.substring(lastIndex),
      match: false
    });
  }
  return parts;
}


    updateContractDetail(){
        if(this.isD2cUser){/**Added for d2c user sold to */
            this.formData.requestOrder.tpDetails['soldTo']=this.tradeData.name1
        }
        this.http.postRequest(this.formData,'returnOrder/v1/updateReturnOrder')
            .subscribe(
                (res:any) => { 
                    if(res.status.toLowerCase()!='error'){
                        this.isAnyChanged=false
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = "Successfully updated.";
                        this.http.onEnd();
                    }else{
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg =res.errorMessage||"Failed to process request. Please contact administrator.";
                        this.http.onEnd();
                    }

                 },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
   
    }

    selectChanged(){
        this.isAnyChanged=true;
    }

    /** for d2c user*/
    setd2cUserAddress(data){
        let addressArray=data.pickupAddress.split('#');
        let nameArray=data.contactName.split(' ')
        let onetTimeAddress= {
            'name1': nameArray[0],
            'name2': nameArray[1],
            'contactEmail': data.contactEmail,
            'contactPhone': data.contactPhone,
            'city': addressArray[0],
            'street': addressArray[1],
            'country': addressArray[2],
            'zipCode': addressArray[3],
        }
        this.requestOrder['tpDetails']=onetTimeAddress;
        this.requestOrder['contactEmail']=null;
        this.requestOrder['contactName']=null;
        this.requestOrder['contactPhone'] = null;
        this.requestOrder['pickupAddress']=null;
    }
}


// view open dialog

@Component({
    template: require('./view.component.html'),
    providers: [HttpService,SessionHandler]
})
export class viewDialog implements OnInit {
    //url: string = "https://storage.googleapis.com/kitchenaid-web-return-dev.appspot.com/ReturnUploadedDocs/challan_receipt.pdf";
    urlSafe: SafeResourceUrl;
    urlList :any = [];
    safeUrlList :any = [];
    constructor(public dialog: MdDialog,private commonService : CommonService, public sanitizer: DomSanitizer){
        
    }
    ngOnInit(): void {
        //this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
       
    }

    public fullView(docUrl){
        window.open(docUrl, "_blank");
    }

    public closeDialog(){
        this.dialog.closeAll();
    }

    
}
   




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/create/create.component.ts